<template>
  <section
    v-if="!message && typeAlert === 'quiz' && !quizHasEnded && !loader"
    class="w-full bg-h-primary-100 shadow-sm z-10 select-none fixed"
  >
    <div
      class="flex flex-col gap-3 md:flex-row justify-between items-center p-5 pr-[50px]"
    >
      <p class="flex flex-col md:flex-row gap-3 text-center">
        <span class="font-[700]">{{ data?.chapter?.concat(" - ") }}</span>
        <span>{{ data?.name }}</span>
      </p>

      <div id="chronometer">
        <div
          :class="`p-3 bg-white rounded-lg border flex items-center justify-center gap-2 ${
            hasTimeout ? 'text-h-error-400' : ''
          }`"
        >
          <v-icon name="hi-solid-clock" />

          <CountDown
            :time="quiz?.duration * 1000"
            v-slot="{ hours, minutes, seconds }"
            @end="onCountdownEnd()"
          >
            <div class="flex items-center gap-1">
              <p v-if="hours">{{ String(hours)?.concat("h") }}</p>
              <p>{{ String(minutes)?.concat("m") }}</p>
              <p>{{ String(seconds)?.concat("s") }}</p>
            </div>
          </CountDown>
        </div>
      </div>
    </div>
  </section>

  <Dialog
    v-model:visible="hasTimeout"
    :closable="false"
    :draggable="false"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    :modal="true"
    :showHeader="false"
    contentStyle="background-color: #F2F8FF"
  >
    <section class="grid grid-cols-12 mt-8 gap-5 items-center">
      <div class="col-span-12 md:col-span-4 flex justify-center">
        <img
          :src="require('@/assets/images/avatares/repproved.gif')"
          class="w-100 rounded-full"
          alt="repproved img"
          loading="lazy"
        />
      </div>
      <div
        class="col-span-12 md:col-span-8 flex flex-col gap-5 text-center lg:text-start"
      >
        <p class="font-bold text-xl">{{ $t("quiz.timeout.title") }}</p>
        <p class="text-sm w-100">{{ $t("quiz.timeout.info") }}</p>
        <MessageVoice
          :msg="$t('quiz.timeout.title')?.concat($t('quiz.timeout.info'))"
        />
        <Button class="btn-primary p-button-sm" @click="onResult()">
          <p>{{ $t("quiz.finalize") }}</p>
        </Button>
      </div>
    </section>
  </Dialog>
</template>

<script lang="ts">
import { ChatBotService } from "@/components/ChatBot/chat-bot.service";
import { QuizService } from "@/views/Quiz/quiz.service";
import { defineComponent } from "vue";

export default defineComponent({
  name: "headerContent",
  emits: [
    "onVerifyMaterials",
    "onCountdownEnd",
    "onResult",
    "onCheckVideoEnded",
  ],
  computed: {
    service(): QuizService {
      return new QuizService();
    },
    chatbotService(): ChatBotService {
      return new ChatBotService();
    },
  },
  data() {
    return {
      hasTimeout: false as boolean,
    };
  },
  props: {
    data: [Object],
    quiz: [Object],
    message: [Boolean],
    typeAlert: [String],
    quizHasEnded: [Boolean],
    loader: [Boolean],
    indexMaterial: [Number],
  },
  methods: {
    onVerifyMaterials(value: number): void {
      this.$emit("onVerifyMaterials", value);
    },
    onOpenFeedback(feedbackType: string): void {
      this.$emit("onCheckVideoEnded", feedbackType);
    },
    onCountdownEnd(): void {
      this.hasTimeout = true;
      this.$emit("onCountdownEnd");
    },
    onResult(value?: boolean): void {
      this.hasTimeout = false;
      this.$emit("onResult", value);
    },
  },
});
</script>
